<template>
  <CheckFormBox :title="$t('hzmbChange.title.new_vehicle')">
    <el-row :gutter="48" type="flex">
      <el-col v-if="!isChangeDriver" :xs="24" :sm="24">
        <div class="form_label">
          {{ $t("hzmbChange.label.registrationNo") }}：
        </div>
        <div class="form_value">{{ data.registrationNo }}</div>
      </el-col>
      <template v-if="!isGHCompany">
        <el-col :xs="24" :sm="24">
          <div class="form_label">
            {{ $t("hzmbChange.label.macauInsuranceNo") }}：
          </div>
          <div class="form_value">{{ data.vehicleInsuranceNo }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">{{ $t("hzmbChange.label.macauInsuranceStartDate") }}：</div>
          <div class="form_value">
            {{ data.vehicleInsuranceStartDate | formatDT("dd/MM/yyyy") }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.macauInsuranceEndDate") }}：
          </div>
          <div class="form_value">
            {{ data.vehicleInsuranceEndDate | formatDT("dd/MM/yyyy") }}
          </div>
        </el-col>
      </template>
      <template v-if="!isChangeDriver || (isChangeDriver && form.renew)">
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.hkInsuranceCompany") }}：
          </div>
          <div class="form_value">{{ data.vehicleInsuranceCompanyNoHk }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.hkInsuranceNo") }}：
          </div>
          <div class="form_value">{{ data.vehicleInsuranceNoHk }}</div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.hkInsuranceStartDate") }}：
          </div>
          <div class="form_value">
            {{ data.vehicleInsuranceStartDateHk | formatDT("dd/MM/yyyy") }}
          </div>
        </el-col>
        <el-col :xs="24" :sm="12">
          <div class="form_label">
            {{ $t("hzmbChange.label.hkInsuranceEndDate") }}：
          </div>
          <div class="form_value">
            {{ data.vehicleInsuranceEndDateHk | formatDT("dd/MM/yyyy") }}
          </div>
        </el-col>
      </template>
      <el-col v-if="hasChangeVehicle" :xs="24" :sm="12">
        <div class="form_label">
          {{ $t("hzmbChange.label.mainlandRegistrationNo") }}：
        </div>
        <div class="form_value">
          {{ data.plateNoCn ? "粤" : "" }}&nbsp;{{ data.plateNoCn }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{ $t("hzmbChange.label.mainlandInsuranceNo") }}：
        </div>
        <div class="form_value">{{ data.vehicleInsuranceNoCn }}</div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{ $t("hzmbChange.label.mainlandInsuranceStartDate") }}：
        </div>
        <div class="form_value">
          {{ data.vehicleInsuranceStartDateCn | formatDT("dd/MM/yyyy") }}
        </div>
      </el-col>
      <el-col :xs="24" :sm="12">
        <div class="form_label">
          {{ $t("hzmbChange.label.mainlandInsuranceEndDate") }}：
        </div>
        <div class="form_value">
          {{ data.vehicleInsuranceEndDateCn | formatDT("dd/MM/yyyy") }}
        </div>
      </el-col>
    </el-row>
  </CheckFormBox>
</template>

<script>
import CheckFormBox from "@/view/DataRegistration/Check/components/CheckFormBox.vue";
export default {
  props: ["data", "form"],
  components: { CheckFormBox },
  data() {
    return {};
  },
  computed: {
    serviceType() {
      return this.$route.params.serviceType;
    },
    isChangeDriver() {
      return this.form.changeType === "CHANGE_DRIVER";
    },
    hasChangeVehicle() {
      const { changeType } = this.form;
      return ["CHANGE_VEHICLE", "CHANGE_VEHICLE_DRIVER"].includes(changeType);
    },
    isGHCompany() {
      return this.serviceType === "HZMB_GH_CHANGE_COMP";
    },
  },
};
</script>
